import { render, staticRenderFns } from "./yuLin.vue?vue&type=template&id=06b6cbdf&scoped=true&"
import script from "./yuLin.vue?vue&type=script&lang=js&"
export * from "./yuLin.vue?vue&type=script&lang=js&"
import style0 from "./yuLin.vue?vue&type=style&index=0&id=06b6cbdf&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b6cbdf",
  null
  
)

export default component.exports